<template>
  <div>
    <div class="mb-2"><b class="white--text">{{ $t('1') }}</b></div>
    <v-card class="px-4" flat>
      <v-layout wrap justify-space-between>
        <v-flex xs5>
          <v-text-field v-model="dossier.profile.trigram" dense outlined :label="$t('2')"/> 
        </v-flex>
        <v-flex xs5>
          <v-text-field v-model="dossier.profile.xpYears" type="number" step="any" min="0" dense outlined :label="$t('3')"/>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-space-between>
        <v-flex xs5>
          <v-text-field v-model="dossier.profile.firstName" dense outlined :label="$t('4')"/>
        </v-flex>
        <v-flex xs5>
          <v-text-field v-model="dossier.profile.lastName" dense outlined :label="$t('5')"/>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-space-between>
        <v-flex xs5>
          <v-text-field v-model="dossier.profile.topDegree" dense outlined :label="$t('6')"/>
        </v-flex>
        <v-flex xs5>
          <v-text-field v-model="dossier.profile.birthYear" dense outlined :label="$t('7')"/>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field v-model="dossier.profile.title" dense outlined :label="$t('8')"/>
        </v-flex>
      </v-layout>
    </v-card>

  </div>
</template>

<script>


export default {
  props: {
    dossier: Object,
    isOcrResultsLoaded: Boolean,
  },
  data: () => ({
    isShowingTextSelectionExample: false,
    images: {
      textSelectionExample: require('@/assets/app/images/textSelectionExample.png'),
    },
  }),
  computed: {
    trigram() {
      return this.dossier.profile.trigram
    },
    firstName() {
      return this.dossier.profile.firstName
    },
    lastName() {
      return this.dossier.profile.lastName
    },
  },
  methods: {
  },
  watch: {
    trigram: {
      handler() {
        this.dossier.profile.trigram = this.trigram.toUpperCase()
      },
    },
    firstName: {
      handler() {
        this.dossier.profile.fullName = [this.dossier.profile.firstName, this.dossier.profile.lastName].filter(Boolean).join(' ')
      },
    },
    lastName: {
      handler() {
        this.dossier.profile.fullName = [this.dossier.profile.firstName, this.dossier.profile.lastName].filter(Boolean).join(' ')
      },
    },
  }
}
</script>


<i18n>
{
  "fr": {
    "1": "Présentation",
    "2": "Trigramme",
    "3": "Années d'expérience",
    "4": "Prénom",
    "5": "Nom de famille",
    "6": "Niveau de diplôme",
    "7": "Année de naissance",
    "8": "Titre du candidat",
    "a": "Sélectionnez rapidement du texte dans le CV en cliquant sur les boutons noirs",
    "b": "Voir un exemple",
    "video1": "Comment sélectionner du texte dans le CV original"

  },
  "en": {
    "1": "Presentation",
    "2": "Trigram",
    "3": "Years of experience",
    "4": "First name",
    "5": "Last name",
    "6": "Top degree",
    "7": "Year of birth",
    "8": "Title of the candidate",
    "a": "Instantly select text from the original CV by using the black buttons",
    "b": "See an example",
    "video1": "How to select text from the original CV"
  }
}
</i18n>